import Svg from 'components/utilities/svg'

const FastForwardIcon = ({ ...props }) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <title>Fast Forward Icon</title>
    <g fill="none">
      <path d="M0 0h24v24H0z" />
      <path d="M0 0h24v24H0z" />
      <path d="M0 0h24v24H0z" />
    </g>
    <path d="M15 9.86 18.03 12 15 14.14V9.86m-9 0L9.03 12 6 14.14V9.86M13 6v12l8.5-6L13 6zM4 6v12l8.5-6L4 6z" />
  </Svg>
)

FastForwardIcon.displayName = 'FastForward'

export default FastForwardIcon
